module.exports = __webpack_public_path__ + "img/reply.c57df5b7.svg";